import React from 'react';
// , { lazy }

import Categories from '@/views/Categories';
import Stage from '@/views/Stage';
import Prestage from '@/views/Prestage';
import BookCover from '@/views/BookCover/indexNew';
import Reading from '@/views/Reading';
import Exercises from '@/views/Exercises';
import Share from '@/views/Share/indexNew';
import ShareWork from '@/views/H5/ShareWork';
import ShareRecording from '@/views/H5/ShareRecording';
import ShareReport from '@/views/H5/ShareReport';
import ReadingReport from '@/views/ReadingReport';
import ReadingShare from '@/views/ReadingShare';
import Report from '@/views/Report';
import demoRouteConfig from './Demo';
// import Test from '@/views/Sudoku';

// const Categories = lazy(() => import('@/views/Categories'));
// const Stage = lazy(() => import('@/views/Stage'));
// const BookCover = lazy(() => import('@/views/BookCover'));
// const Reading = lazy(() => import('@/views/Reading'));
// const Exercises = lazy(() => import('@/views/Exercises'));
// const Share = lazy(() => import('@/views/Share'));
// const ShareWork = lazy(() => import('@/views/H5/ShareWork'));
// const ShareRecording = lazy(() => import('@/views/H5/ShareRecording'));
// const ShareReport = lazy(() => import('@/views/H5/ShareReport'));
// const Report = lazy(() => import('@/views/Report'));

const publicRouteConfig = [{
  path: '/',
  exact: true,
  component: () => <Categories />,
}, {
  path: '/categories',
  exact: true,
  component: () => <Categories />,
}, {
  path: '/stage/:theme/:id/:id2?',
  exact: true,
  component: () => <Stage />,
}, {
  path: '/prestage/:stageId/:id',
  exact: true,
  component: () => <Prestage />,
}, {
  path: '/cover/:id/:attempt/:stage/:stageId',
  exact: true,
  component: () => <BookCover />,
}, {
  path: '/reading/:id/:attempt/:stage/:stageId',
  exact: true,
  component: () => <Reading />,
}, {
  path: '/exercises/:id/:attempt/:stage/:stageId',
  exact: true,
  component: () => <Exercises />,
}, {
  path: '/share/:id/:attempt/:stage/:stageId',
  exact: true,
  component: () => <Share />,
}, {
  path: '/share_work/:id/:shareId/:attempt',
  exact: true,
  component: () => <ShareWork />,
}, {
  path: '/share_recording/:id/:shareId/:attempt',
  exact: true,
  component: () => <ShareRecording />,
}, {
  path: '/share_report/:id/:shareId/:attempt',
  exact: true,
  component: () => <ShareReport />,
}, {
  path: '/report/:id/:attempt/:stage/:stageId',
  exact: true,
  component: () => <Report />,
}, {
  path: '/reading_report/:id/:attempt/:stage/:stageId/:new_attempt?',
  exact: true,
  component: () => <ReadingReport />,
}, {
  path: '/reading_share/:id/:attempt/:stage/:stageId/:new_attempt/:uid?/:pid?',
  exact: true,
  component: () => <ReadingShare />,
}];

export default [...publicRouteConfig, ...demoRouteConfig];
